export const UPSC_TICKER_CMS_API_PATH = 'upsc-current-affairs-ticker';
export const normalizeUpscTickerResponse = (data) => {
  const rawItems = data?.items;

  if (!Array.isArray(rawItems)) {
    return [];
  }

  return rawItems
    .map((item) => ({
      heading: item?.heading,
      link: item?.link
    }))
    .filter((item) => Boolean(item.heading));
};
